import * as React from 'react';
import { connect } from 'react-redux';

import { ModalOpener } from 'components/modal';
import ListsCreateEditDummyModal from 'modules/lists/components/list-create-edit-modal/ListCreateEditDummyModal';

import {
  saveCollectionAndSaveEntitiesToIt,
  toggleModal
} from 'modules/create-new-profiles/reducers/actions';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./create-new-profiles-new-collection-modal.i18n.json'));

import { ListMeta, State } from 'types';

interface StateProps {
  isOpen: boolean,
  organizationId: number
}

interface DispatchProps {
  dispatchOnClose: () => void,
  dispatchSaveCollectionAndSaveEntitiesToIt: (
    list: ListMeta,
    organizationId: number,
    listId?: number | null,
    shouldUpdate?: boolean | null
  ) => Promise<void>
}

type Props = StateProps & DispatchProps

const CreateNewProfilesNewCollectionModal = ({
  isOpen,
  organizationId,
  dispatchOnClose,
  dispatchSaveCollectionAndSaveEntitiesToIt
}: Props): JSX.Element => (
  <ModalOpener
    showClose
    open={isOpen}
    onClose={dispatchOnClose}
  >
    <ListsCreateEditDummyModal
      title={__t('create_new_profiles_new_collection_modal.title')}
      organizationId={organizationId}
      onCloseModal={dispatchOnClose}
      dispatchSaveList={dispatchSaveCollectionAndSaveEntitiesToIt}
    />
  </ModalOpener>
);

const mapStateToProps = ({ createNewProfiles, organizations }: State): StateProps => ({
  isOpen: createNewProfiles.activeModal === 'new-collection',
  organizationId: organizations.currentOrganization?.id ?? -1
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchOnClose: () => dispatch(toggleModal(null)),
  dispatchSaveCollectionAndSaveEntitiesToIt: (
    list, orgId, listId, update
  ) => dispatch(saveCollectionAndSaveEntitiesToIt(list, orgId, listId, update))
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewProfilesNewCollectionModal);
